/**
 * @module
 */
define('eventLogger',["routes", "ajaxHelper", "analyticsHelper", "performanceEventsQueue"], function (routes, ajax, analyticsHelper, performanceEventsQueue) {
    var callAddThis = true;
    var commIdHd = 0;
    var builderIdHd = 0;
    var siteRoot = document.getElementById("nhs_siteRoot").value;
    var marketId = document.getElementById("nhs_marketId").value;
    var _communityId = document.getElementById("nhs_communityId").value;
    var _builderId = document.getElementById("nhs_builderId").value;
    var _planId = document.getElementById("nhs_planId").value;
    var _specId = document.getElementById("nhs_specId").value;
    var _homeSearchViewMetricDisplayed = null;
    var _homeSearchViewMetricHidden = null;
    var fromPage = null;
    var performanceLogUrl = routes.performanceLog;
    var eventLoggerUrl = "eventlogger/logevent-";

    /**
     * Checks if the Google Analytics library has been downloaded yet
     * @function
     */
    function isGaLoaded() {
        return typeof (ga) === "function" && typeof (ga.getAll) === "function" ;
    }

    /**
     * Handles the url event log, if GA is ready then we log the event,
     * otherwise we are going to enqueue it and wait for the pageLoad event before trying to log them
     * @function
     * @param {String} url String
     * @param {String} isGaReady String
     * @param {Boolean} isAsync Boolean
     */
    function handleLogEvent(url, isGaReady, isAsync) {
        if (!isGaReady) {
            performanceEventsQueue.enqueueEvent(url);
        } else {
            url = analyticsHelper.addAnalyticsUrlParameters(url);
            ajax.postRequest(url, { async: isAsync });
        }
    }

    /**
     * Redirects the window
     * @function
     * @param {Event} e Event
     * @param {String} url URL
     * @param {*} newWin New Window
     */
    function redirect(e, url, newWin) {
        try {
            e.cancelBubble = true;
        } catch (err) {}

        if (e.stopPropagation) {
            e.stopPropagation();
        }

        if (!url) return;

        if (!!(navigator.userAgent.indexOf("Trident/") >= 0 || navigator.userAgent.indexOf("MSIE ") >= 0)) {
            var referLink = document.createElement("a");

            referLink.href = url;
            document.body.appendChild(referLink);

            //Begin Case: 79000
            if (newWin) {
                referLink.target = "_blank";
                referLink.click();
            } else {
                setTimeout(function () {
                    referLink.click();
                }, 500);
            }
            //End Case: 79000
        } else {
            if (newWin) {
                window.open(url);
            } else {
                setTimeout(function () {
                    window.location.href = url;
                }, 500);
            }
        }

    }

    /**
     * Logs a view using parameters
     * @function
     * @param {String} url 
     * @param {Number} eventCode 
     * @param {*} parameters 
     */
    function logViewWithParameters(url, eventCode, parameters) {
        var wturl = url;

        if (fromPage === "communityresults") {
            wturl = url;

            if (siteRoot === "/") {
                wturl = "/NewHomeSource" + url;
            }
        }

        var communityId = 0,
            specId = 0,
            planId = 0;

        if (parameters.builderId) {
            url = url + "/builder-" + parameters.builderId;
        }

        if (parameters.communityId || parameters.commId) {
            url = url + "/community-" + (parameters.communityId || parameters.commId);
            communityId = (parameters.communityId || parameters.commId);
        }

        if (parameters.parentCommunityId || parameters.parentCommId) {
            url = url + "/parentcommunityid-" + (parameters.parentCommunityId || parameters.parentCommunityId);
        }

        if (parameters.communityList) {
            url = url + "/communitylist-" + parameters.communityList;
        }

        if (parameters.marketId) {
            url = url + "/market-" + parameters.marketId;
        }

        if (parameters.planId) {
            url = url + "/planid-" + parameters.planId;
            planId = parameters.planId;
        }

        if (parameters.specId) {
            url = url + "/specid-" + parameters.specId;
            specId = parameters.specId;
        }

        if (parameters.basicListingId) {
            url = url + "/basiclistingid-" + parameters.basicListingId;
        }

        if (parameters.refer) {
            url = url + "/refer-" + parameters.refer;
        }

        if (parameters.totalHomes) {
            url = url + "/totalhomes-" + parameters.totalHomes;
        }

        if (parameters.builderCommunityList) {
            url = url + "?buildercommunitylist=" + parameters.builderCommunityList;
        }

        if (parameters.basicListingList) {
            url = url + "?basiclistinglist=" + parameters.basicListingList;
        }

        if (parameters.homeList) {
            url = url + "?homeList=" + parameters.homeList;
        }

        var isGaReady = isGaLoaded();
        handleLogEvent(url, isGaReady, true);

        //GA Performance event (with enhaced ecomm)
        logGoogleEcommerceEvent(eventCode, communityId, specId, planId, null, parameters.builderCommunityList, parameters.homeList);
    }

    /**
     * Logs a view
     * @function
     * @param {String} url URL
     * @param {Number} eventCode Event code
     * @param {Number} cid Community Id
     * @param {Number} bid Builder Id
     * @param {Number} planId Plan Id
     * @param {Number} specId Spec Id
     * @param {Number} bsId BS Id
     */
    function logView(url, eventCode, cid, bid, planId, specId, bsId) {
        if (url.indexOf("http://") < 0) {
            url = url.replace(" ", "").replace("//", "/");
        }

        var hdPage = planId > 0 || specId > 0;

        if (cid === 0 && hdPage) {
            cid = commIdHd;
        }

        if (bid === 0 && hdPage) {
            bid = builderIdHd;
        }

        //Log to custom via http req 
        if (bsId === 0) {
            url = url + "/builder-" + bid + "/community-" + cid + "/planid-" + planId + "/specid-" + specId + "/market-" + marketId;
        } else {
            url = url + "/basiclistingid-" + bsId + "/market-" + marketId;
        }

        var isGaReady = isGaLoaded();
        handleLogEvent(url, isGaReady, true);

        //GA Performance event (with enhaced ecomm)
        logGoogleEcommerceEvent(eventCode, cid, specId, planId, null);
    }

    /**
     * Logs Metrics
     * @function
     * @param {Event} event Event
     * @param {String} logString String to log
     */
    function logMetrics(event, logString) {
        ajax.request({
            type: "POST",
            url: "https://" + location.host + "/metricseventlogger/",
            data: {
                logsInChains: logString,
                eventName: event
            }
        });
    }

    /**
     * Logs a Google Ecommerce Event
     * @function
     * @param {String} eventName Event name
     * @param {Number} communityId Community Id
     * @param {Number} specId Spec Id
     * @param {Number} planId Plan Id
     * @param {String} builderName Builder's name
     * @param {Number[]} communitiesIdsList Communities Id List
     * @param {Number[]} homesIdsList Homes Id List
     */
    function logGoogleEcommerceEvent(eventName, communityId, specId, planId, builderName, communitiesIdsList, homesIdsList) {
        ajax.request({
            type: "POST",
            url: performanceLogUrl,
            data: {
                "eventName": eventName,
                "communityId": typeof (communityId) != "undefined" && communityId != null ? communityId : 0,
                "specId": typeof (specId) != "undefined" && specId != null ? specId : 0,
                "planId": typeof (planId) != "undefined" && planId != null ? planId : 0,
                "builderName": builderName,
                "communitiesIdsList": communitiesIdsList,
                "homesIdsList": homesIdsList
            },
            success: function (result) {
                // The GetDataLayerPush method of the Google Analytics Controller returns a js that needs to be executed
                eval(result);
            }
        });
    }

    /**
     * Creates an EventLogger instance
     * @constructor
     */
    function EventLogger() {}

    /**
     * Logs List Hub Events
     * @method
     * @param {String} listHubProviderId List Hub provider Id
     * @param {String} testkey Test Key
     * @param {String} desckey Description Key
     * @param {String} listingKey Listing Key
     */
    EventLogger.prototype.logListHubEvent = function (listHubProviderId, testkey, desckey, listingKey) {
        try {
            var _lh = new ListHubTracker({
                provider: listHubProviderId,
                test: testkey
            });
            _lh.submit(desckey, listingKey);
        } catch (err) {}
    };

    /**
     * Logs and Redirects
     * @method
     * @param {Event} e Event
     * @param {String} url Url
     * @param {Number} eventCode Event code
     * @param {Number} cid Community Id
     * @param {Number} bid Builder Id
     * @param {Number} pid Plan Id
     * @param {Number} sid Spec Id
     * @param {Number} mid Market Id
     * @param {Boolean} external If the redirect is to an external page
     * @returns {Boolean} False
     */
    EventLogger.prototype.logAndRedirect = function (e, url, eventCode, cid, bid, pid, sid, mid, external) {
        marketId = mid;
        this.logEvent(eventCode, cid, bid, pid, sid);
        redirect(e, url, external);
        return false;
    };

    /**
     * Logs Basic Listing and Redirects
     * @method
     * @param {Event} e Event
     * @param {String} url Url
     * @param {Number} eventCode Event code
     * @param {Number} bsid Basic Id
     * @param {Number} mid Market Id
     * @returns {Boolean} False     
     */
    EventLogger.prototype.logBasicListingAndRedirect = function (e, url, eventCode, bsid, mid) {
        var params = {
            basiclistingId: bsid,
            marketId: mid
        };
        this.logEventWithParameters(eventCode, params);
        redirect(e, url);
        return false;
    };

    /**
     * Logs using parameters and Redirects
     * @method
     * @param {Event} e Event
     * @param {String} url Url
     * @param {Number} eventCode Event code
     * @param {*} params Bs Id
     * @param {Boolean} external If the redirect is to an external page
     * @returns {Boolean} False
     */
    EventLogger.prototype.logWithParametersAndRedirect = function (e, url, eventCode, params, external) {
        this.logEventWithParameters(eventCode, params);
        redirect(e, url, external);
        return false;
    };

    /**
     * Logs Basic Listing event
     * @method
     * @param {Number} eventCode Event code
     * @param {Number} bsid Basic Id
     */
    EventLogger.prototype.logBasicListingEvent = function (eventCode, bsid) {
        if (!eventCode) return;
        var url = siteRoot + routes.logEvent + eventCode;

        if (siteRoot.substring(siteRoot.length - 1) !== "/") {
            url = "/" + url;
        }

        logView(url, eventCode, 0, 0, 0, 0, bsid);
    };

    /**
     * Logs an event
     * @method
     * @param {Number} eventCode Event code
     * @param {Number} cid Community Id
     * @param {Number} bid Builder Id
     * @param {Number} pid Partner Id
     * @param {Number} sid Spec Id
     */
    EventLogger.prototype.logEvent = function (eventCode, cid, bid, pid, sid) {
        if (!eventCode) return;
        var url = siteRoot + routes.logEvent + eventCode;

        if (siteRoot.substring(siteRoot.length - 1) !== "/") {
            url = "/" + url;
        }

        logView(url, eventCode, cid, bid, pid, sid, 0);
    };

    /**
    * Log events with parameters
    * @function
    * @param {Number} eventCode
    * @param {*} parameters
    */
    EventLogger.prototype.logEventWithParameters = function (eventCode, parameters) {
        var self = this;

        setTimeout(function () {
            if (eventCode) {
                var url = siteRoot + eventLoggerUrl + eventCode;

                if (siteRoot.substring(siteRoot.length - 1) != "/") {
                    url = "/" + url;
                }

                logViewWithParameters(url, eventCode, parameters);
            }
        }, self._timeOut);
    };

    /**
     * Sets an allowance to add this
     * @method
     */
    EventLogger.prototype.setAllowAddThis = function () {
        callAddThis = false;
        setTimeout(function () {
            callAddThis = true;
        }, 2000);
    };

    /**
     * Logs Multiple events
     * @method
     * @param {Event} e Event
     * @param {String} url Url
     * @param {Number} eventCode Event code
     * @param {Number} bsid Bs Id
     * @param {Number} mid Market Id
     */
    EventLogger.prototype.logMultiEvent = function (eventCode, communityId, builderId, planId, specId) {
        if (eventCode) {
            var url = siteRoot + routes.logEvent + eventCode;

            if (siteRoot.substring(siteRoot.length - 1) !== "/") {
                url = "/" + url;
            }

            logView(url, eventCode, communityId, builderId, planId, specId, 0);
        }
    };

    /**
     * Logs Home Results metrics
     * @method
     * @param {String} eventCode Event Code
     * @param {Boolean} flag Flag
     */
    EventLogger.prototype.logHomeResultsMetrics = function (eventCode, flag) {
        if (eventCode) {
            var logString;

            if (flag === 1) {
                logString = _homeSearchViewMetricDisplayed;
            } else {
                logString = _homeSearchViewMetricHidden;
            }

            logMetrics(eventCode, logString);
        }
    };

    /**
     * Attaches Events to add this
     * @method
     */
    EventLogger.prototype.attachEventsToAddThis = function () {
        var instance = this;
        if (typeof addthis !== "undefined") {
            addthis.addEventListener("addthis.menu.share", function (evt) { // TODO check this event 
                if (!callAddThis) return;
                var serviceShared = evt.data.service.toString().toLowerCase();
                var eventCode, hdPage;

                if (serviceShared.indexOf("favorites") === -1 && serviceShared.indexOf("print") === -1 && serviceShared.indexOf("email") === -1) {
                    if (_planId === 0 && _specId === 0 && _communityId === 0) {
                        eventCode = "MHSMS";
                    } else {
                        hdPage = _planId > 0 || _specId > 0;
                        eventCode = hdPage ? "HDSMS" : "CDSMS";
                    }

                    instance.logMultiEvent(eventCode, _communityId, _builderId, _planId, _specId);
                } else if (serviceShared.indexOf("email") > -1) {
                    hdPage = _planId > 0 || _specId > 0;
                    eventCode = hdPage ? "HOMSTF" : "COMSTF";
                    instance.logMultiEvent(eventCode, _communityId, _builderId, _planId, _specId);
                    instance.setAllowAddThis();
                } else if (serviceShared.indexOf("print") > -1) {
                    hdPage = _planId > 0 || _specId > 0;
                    eventCode = hdPage ? "HOMPR" : "COMPR";

                    if (this.classList.contains("nextStepsPrint")) {
                        eventCode = hdPage ? "HDNSPRN" : "CDNSPRN";
                    }

                    var logInfo = getLogInfo();

                    instance.logEventWithParameters(eventCode, logInfo);
                    instance.setAllowAddThis();
                }

            });
        }
    };

    /**
     * Gets log info
     */
    EventLogger.prototype.getLogInfo = function () {
        var logInformationObject;
        var logInfo = {
            communityId: _communityId,
            builderId: _builderId,
            planId: _planId,
            specId: _specId
        };

        if (typeof commDetail != "undefined") {
            logInformationObject = commDetail._parameters || commDetail.parameters;
            logInfo = logInformationObject.logInfo;
        }
        else if (typeof homeDetail != "undefined") {
            logInformationObject = homeDetail._parameters || homeDetail.parameters;
            logInfo = logInformationObject.logInfo;
        }

        return logInfo;
    };

    /**
     * Sets a Pair to the Data Layer
     * @method
     * @param {String} key Key
     * @param {*} optValue Optional value
     */
    EventLogger.prototype.SetDataLayerPair = function (key, optValue) {
        try {
            var finalUrl = "/GoogleAnalytics/SetDataLayerPair";

            if (typeof (optValue) == "undefined") {
                optValue = 0;
            }

          ajax.getRequest(finalUrl + "?key=" + key + "&optValue=" + optValue + "", null, null,
            {
              async: true,
              success: function(data) {
                if (!(data !== "" && typeof data === "string")) return;
                if (typeof (dataLayer) == "undefined") {
                  var tmpData = data;
                  var finalData = tmpData.replace("dataLayer", "window.parent.dataLayer");
                  eval(finalData);
                } else {
                  eval(data);
                }
              }
            });
        } catch (ex) {}
    };

    /**
    * Creates a cookie
    * @method
    * @param {String} name Name
    * @param {String | Number | Boolean} value Value
    * @param {Number} days Days
    */
    function createCookie(name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    };


    EventLogger.prototype.createCookie = createCookie;

    /**
    * reads the cookie with a given name
    *@method 
    *
    * @param {string} name Name of the cookie
    * @returns
    */
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    EventLogger.prototype.readCookie = readCookie;

    /**
    * Executes google push functionality
    * @method
    * @param {Event[]} events Event List
    * @param {String} action Action
    * @param {String} label Label
    * @param {String | Number | Boolean} value Value
    */
    EventLogger.prototype.googlepush = function (events, action, label, value) {
        createCookie("CTAName", action);
        if (typeof dataLayer !== "undefined") {
            dataLayer.push({
                'event': "GAEvent",
                'eventCategory': events,
                'eventAction': action,
                'eventLabel': label,
                'eventValue': undefined
            });
        } 
    };

    return EventLogger;
});
